import * as React from 'react';
import { Layout, Tooltip } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';
import { AuthContext } from '../LocalAuthWrapper';
import { NavLink } from 'react-router-dom';
import { KEYCLOAK_ADMIN_GROUP } from '../config';

const { Footer: AntFooter } = Layout;

const Footer: React.FC<{}> = () => (
  <AntFooter
    style={{
      backgroundColor: '#f7f7f7',
      padding: '1em 1em',
    }}
  >
    <a href='https://tiro.is'>Tiro</a> - <a href='https://tiro.is/personuverndarstefna'>Persónuverndarstefna</a> -
    <AuthContext.Consumer>
      {(value) => {
        if (value.userDetails && value.userDetails.groups && value.userDetails.groups.includes(KEYCLOAK_ADMIN_GROUP)) {
          return (
            <Tooltip title='Stjórnborð' mouseEnterDelay={1.5}>
              <NavLink style={{ marginLeft: '10px' }} to='/admin'>
                <EllipsisOutlined style={{ color: 'black', fontSize: '1.2em' }} />
              </NavLink>
            </Tooltip>
          );
        }
      }}
    </AuthContext.Consumer>
  </AntFooter>
);

export default Footer;
